module.exports = __webpack_public_path__ + "static/fonts/Linearicons-Free.2f3e9f8.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Linearicons-Free.ttf?w118d
// module id = N7sV
// module chunks = 1